<!-- VapiEmbed.vue -->
<template>
  <div class="widget-intervoice">
    <div v-if="loading">
      loading...
    </div>
    <div class="card p-3" v-else>
      <div
        v-if="errorName"
        class="card-body p-3">
        <IntervoiceError
          v-if="errorName"
          :name="errorName" />
      </div>
      <div
        v-else
        class="card-body p-3">
        <div class="mb-4">
          <Logo
            :src="summary.account_id ? summary.account_id.logo_media_url : null"
            max-width="160px" />
        </div>
        <IntervoiceStart
          v-if="!status"
          :token="token"
          :estimed_time_minutes="summary.estimed_time_minutes"
          :total_questions="summary.total_questions"
          @start="start" />
        <IntervoiceMicPermission
          v-if="status === 'mic-permission'"
          @mic-permission-granted="onMicPermissionGranted" />
        <IntervoiceVoiceVapi
          v-if="status === 'conversing'"
          :globalPrompt="globalPrompt"
          :startPrompt="startPrompt"
          :totalTimeSeconds="totalTimeSeconds"
          :token="token"
          @finished="finished" />
        <IntervoiceFinished
          v-if="status === 'finished'" />
      </div>
    </div>
  </div>
</template>

<script>
import IntervoiceStart from './IntervoiceStart.vue'
import IntervoiceFinished from './IntervoiceFinished.vue'
import IntervoiceVoiceVapi from './IntervoiceVoiceVapi.vue'
import IntervoiceMicPermission from './IntervoiceMicPermission.vue'
import IntervoiceError from './IntervoiceError.vue'
import axios from '@/utils/AxiosInstance'
import Logo from '../Logo.vue'

export default {
  name: 'IntervoiceTest',
  components: {
    IntervoiceStart,
    IntervoiceFinished,
    IntervoiceVoiceVapi,
    IntervoiceMicPermission,
    IntervoiceError,
    Logo
  },
  props: {
  },
  data () {
    return {
      status: null, // null | 'conversing' | 'finished'
      loading: false,
      globalPrompt: null,
      startPrompt: null,
      totalTimeSeconds: null,
      summary: {},
      errorName: null
    }
  },
  computed: {
    token () {
      return this.$route.params.token
    }
  },
  created () {
    this.loadData()
  },
  watch: {
  },
  methods: {
    start (data) {
      const { globalPrompt, startPrompt, totalTimeSeconds } = data
      this.globalPrompt = globalPrompt
      this.startPrompt = startPrompt
      this.totalTimeSeconds = totalTimeSeconds
      this.status = 'mic-permission'
    },
    onMicPermissionGranted () {
      this.status = 'conversing'
    },
    async loadData () {
      this.loading = true
      try {
        const { data } = await axios.get(`/guest/intervoice/${this.token}/summary`)
        this.summary = data
      } catch (error) {
        if (error.response && error.response.data) {
          this.errorName = error.response.data.name
        }
        console.error('IntervoiceTest.vue created error:', error)
      } finally {
        this.loading = false
      }
    },
    finished () {
      this.status = 'finished'
    }
  }
}
</script>

<style>
.widget-intervoice {
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}
.widget-intervoice > .card {
  width: 100%;
  max-width: 400px;
}
#vapi-support-btn {
  display: none !important;
}
</style>
